var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BCKeyAssignmentMenu',{attrs:{"keyType":"extendedMenu","setting":_vm.setting}})
}
var staticRenderFns = []

export { render, staticRenderFns }